<h1 mat-dialog-title>Set insumos</h1>
<div>
  <mat-spinner *ngIf="loading"></mat-spinner>
  <!-- table multiselect -->

  <mat-table
    [dataSource]="dataSource"
    *ngIf="!loading"
  >
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef> Seleccionar </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-checkbox
          (change)="toggleSelection(element.Id)"
          [checked]="selection.has(element.Id)"
        >
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef>Nombre</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.Id }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>Nombre</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.Name }}</mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" (click)="save()">Aceptar</button>
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
      Salir
    </button>
  </div>
</div>
